import { askAiInteracted, type OriginActionValueType } from '../Avo';

interface TrackAskLooperOptions {
  isSuggestion?: boolean;
  feedbackRating?: 'up' | 'down';
  hasComment?: boolean;
}

export const trackAskLooperInteracted = (
  originAction: OriginActionValueType,
  options: TrackAskLooperOptions = {},
) => {
  const feedbackType =
    options.feedbackRating === 'up'
      ? 'Thumb Up'
      : options.feedbackRating === 'down'
        ? 'Thumb Down'
        : '';

  askAiInteracted({
    originAction,
    isSuggestion: options.isSuggestion ?? false,
    feedbackType,
    hasComment: options.hasComment ?? false,
  });
};
